export const paramNameOptions = {
    VIEW: 'view',
    MONTHLY: 'monthly',
    SPOTID: 'spot-id',
    OPERATOR_ID: 'operator_id',
    FACILITY: 'facility',
    DESTINATION_ID: 'destination_id',
    HIDE_EVENT_MODAL: 'hide_event_modal',
};
// Ad/campaign attribution params that must survive client-side route rebuilds
export const AD_TRACKING_PARAMS = [
    'gclid',
    'gbraid',
    'wbraid',
    'msclkid',
    'fbclid',
    'sha_affiliate',
    'aff_id',
    'partner',
    'ad_grp_id',
    'branch_referrer',
    'branch_match_id',
    '_branch_referrer',
    '_branch_match_id',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
];
export function updateRouteParam(paramName, paramValue) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set(paramName, paramValue);
    window.history.replaceState({}, '', newUrl.href);
}
export function removeRouteParam(paramName) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete(paramName);
    window.history.replaceState({}, '', newUrl.href);
}
export function getRouteParam(paramName) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    return newUrl.searchParams.get(paramName);
}
/**
 * Get URL parameter value by name from the current URL
 * @returns - Object with the URL parameter name and value or an empty object
 */
export function getUrlParamAsObject(param) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);
    return paramValue ? { [param]: paramValue } : {};
}
/**
 * Get any ad/campaign attribution params present in the given search string,
 * falling back to the current URL's query string when running in a browser.
 * Pass the request/router search string explicitly when calling during SSR.
 * @param search - An optional search string (e.g. `?foo=bar`) to read params from
 * @returns - Object containing only the ad tracking params that are present
 */
export function getAdTrackingParamsAsObject(search) {
    const searchString = search ?? (typeof window === 'undefined' ? '' : window.location.search);
    const [searchStringWithoutFragment] = searchString.split('#');
    const urlParams = new URLSearchParams(searchStringWithoutFragment);
    return AD_TRACKING_PARAMS.reduce((params, param) => {
        const paramValue = urlParams.get(param);
        return paramValue ? { ...params, [param]: paramValue } : params;
    }, {});
}
